import { render, staticRenderFns } from "./NewEditDocumentosPlanosPage.vue?vue&type=template&id=039dc19a&scoped=true"
import script from "./NewEditDocumentosPlanosPage.vue?vue&type=script&lang=js"
export * from "./NewEditDocumentosPlanosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039dc19a",
  null
  
)

export default component.exports